<article class="featured__box">
   <h2 class="featured__heading">{{heading}}</h2>
   <span [class]="'featured__icon featured__icon--' + (icon | lowercase)"></span>
   @if (showBalanceServiceNotAvailable | async; as showBalanceServiceNotAvailable) {
   <p class="featureDesc">{{balanceServiceNotAvailable}}</p>
   } @if (showBalanceNotAvailable | async; as showBalanceNotAvailable) {
   <p class="featureDesc">{{balanceNotAvailable}}</p>
   } @if (balanceText.value !== '') {
   <p class="featured__highlight rent-and-charges ng-isolate-scope" in-arrears-text="in arrears" in-credit-text="in credit">
      @if (isArrear | async; as isArrear) {
      <strong>{{balanceText.value}} <small class="payments__status--arrears">{{inArrears}}</small></strong>
      } @if (isCredit | async; as isCredit) {
      <strong>{{balanceText.value}} <small class="payments__status--credit">{{inCredit}}</small></strong>
      } @if (isArrear.value === false && isCredit.value === false) {
      <strong>{{balanceText.value}}</strong>
      }
   </p>
   } @if (loading) {
   <div>
      <app-spinner></app-spinner>
   </div>
   } @if (showAdditionalSummary) {
   <p class="featureDesc">{{additionalSummaryText}}</p>
   }
   <div class="featured__btns">
      @if (showPrimaryButton) {
      <p>
         <a
            [href]="primaryButtonEnabled ? primaryButtonLink : null"
            [class.disabled]="!primaryButtonEnabled"
            [attr.aria-disabled]="!primaryButtonEnabled"
            class="featured__btn btn btn-block btn-primary"
            [id]="'btn-'+index+'-primary'"
            >{{primaryButtonText}}</a
         >
      </p>
      } @if (showSecondaryButton) {
      <p>
         <a
            [href]="secondaryButtonEnabled ? secondaryButtonLink : null"
            [class.disabled]="!secondaryButtonEnabled"
            [attr.aria-disabled]="!secondaryButtonEnabled"
            class="featured__btn btn btn-block btn-default"
            [id]="'btn-'+index+'-secondary'"
            >{{secondaryButtonText}}</a
         >
      </p>
      }
   </div>
</article>
